import { Navigate, Route, Routes } from 'react-router-dom';
import { Login } from './Login';
import { Register } from './Register';
import { ForgotPassword } from './ForgotPassword';
import { ResetPassword } from './ResetPassword';
import { AccountDetails } from './AccountDetails';
import { ShoppingCart } from './ShoppingCart';
import { Wishlist } from './Wishlist';

export const AccountRoutes = () => {
  return (
    <Routes>
      <Route path="login" element={<Login />} />
      <Route path="register" element={<Register />} />
      <Route path="forgot-password" element={<ForgotPassword />} />
      <Route path="reset-password/:token" element={<ResetPassword />} />
      <Route path="details" element={<AccountDetails />} />
      <Route path="cart" element={<ShoppingCart />} />
      <Route path="wishlist" element={<Wishlist />} />
      <Route path="*" element={<Navigate to="." />} />
    </Routes>
  );
};
